import {Injectable} from '@angular/core';
import {FedexFileState, Store as FedexFileStore} from './store';
import {EntityService} from '../../../components/entity-service';
import {FedexFile} from './model';
import {FieldConfig} from '../../../components/form/field.interface';
import {Validators} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {map, shareReplay, switchMap, take, tap} from 'rxjs/operators';
import {FedexFileQuery} from './query';
import {Observable, of} from "rxjs";
import {AuthService} from "../../../authentication/service/auth.service";
import {User} from "../../../authentication/user/state/model";
import {Order} from "../../order/state/model";
import {InvoiceFile} from "../../invoice-file/state/model";

@Injectable({providedIn: 'root'})
export class FedexFileService extends EntityService<FedexFileStore, FedexFileState> {

  addresses$ = this.authService.user$.pipe(
    switchMap(() => this.get()),
    map(items => items.map(item => new FedexFile(item))),
    shareReplay(1)
  );

  editForm = {
    cancelTitle: this.translocoService.selectTranslate('form.cancel'),
    submitTitle: this.translocoService.selectTranslate('form.submit'),
    entityTitle: this.translocoService.selectTranslate('country.entityTitle'),
    fields: [

      FieldConfig.create({
        type: 'input',
        label: of(''),
        inputType: 'text',
        name: 'order',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
      FieldConfig.create({
        type: 'input',
        label: of(''),
        inputType: 'text',
        name: 'fedexFile',
        listed: false,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
      FieldConfig.create({
        type: 'input',
        label: of(''),
        inputType: 'text',
        name: 'country',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
      FieldConfig.create({
        type: 'input',
        label: of(''),
        inputType: 'text',
        name: 'isDefault',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
    ]
  };

  constructor(
    protected translocoService: TranslocoService,
    private query: FedexFileQuery,
    private authService: AuthService,
    protected store: FedexFileStore) {
    super(store, FedexFile);
  }

  getByOrder(order: Order): Observable<FedexFile[]> {
    return this.getHttp().get<InvoiceFile[]>(this.api + '/detail?q[]=order:eq:' + order.id)
      .pipe(
        map(items => {
          return (items ?? []).map(_item => new this._constructor(_item) as FedexFile);
        }),
        take(1),
        shareReplay(1),
        tap(entity => {
          //this.store.upsertMany([entity as getEntityType<St>]);
        }),
      );
  }

  get resourceName(): string {
    return 'webshop/order-fedex';
  }

}
